export const intentOptions = [
  { label: 'Data Inquiry', value: 'data_inquiry' },
  { label: 'Data Inquiry with Visualizations', value: 'data_inquiry_with_visuals' },
  { label: 'General Assistance', value: 'general_assistance' }
]

export const intervalOptions = [
  { label: 'Daily', value: 'day' },
  { label: 'Weekly', value: 'week' },
  { label: 'Monthly', value: 'month' }
]

export const boundaryOptions = [
  { label: 'Start', value: 'start' },
  { label: 'End', value: 'end' }
]
